import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const HtmlTooltip = styled(Tooltip)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.elevated || '#f5f5f9',
    color: theme.palette.text.primary,
    maxWidth: 250,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

const Label = ({
  variant = 'h1',
  isLink = false,
  url = '',
  className = '', // eslint-disable-line no-unused-vars
  toolTip = '', // eslint-disable-line no-unused-vars
  children,
  ...rest // eslint-disable-line react/jsx-props-no-spreading
}) => {
  const { t } = useTranslation();
  if (isLink) {
    return (
      <Typography
        variant={variant}
        {...rest} // eslint-disable-line react/jsx-props-no-spreading
      >
        <HtmlTooltip
          title={(
            <>
              <Typography color="inherit">
                {url}
              </Typography>
              <em>{t('common.opensInNewTab')}</em>
            </>
          )}
          placement="top"
          arrow
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={url}
          >
            {children}
          </a>
        </HtmlTooltip>
      </Typography>
    );
  }
  return (
    <Typography
      variant={variant}
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
    >
      {` ${children} `}
    </Typography>
  );
};

Label.propTypes = {
  variant: PropTypes.string,
  isLink: PropTypes.bool,
  url: PropTypes.string,
  toolTip: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.string.isRequired,
};

export default Label;
